// extracted by mini-css-extract-plugin
export default {"center":"Kl65YtuHmn2wJq5GNFFb","slider":"KnZy3_WOxwWLUFPPYMM7"};